var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 9,
    fill: "#0066FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 19.5C24 15.916 26.916 13 30.5 13C34.084 13 37 15.916 37 19.5C37 23.084 34.084 26 30.5 26C26.916 26 24 23.084 24 19.5ZM32 22C32.256 22 32.512 21.902 32.707 21.707C33.098 21.316 33.098 20.684 32.707 20.293L31.5 19.086V17C31.5 16.447 31.052 16 30.5 16C29.948 16 29.5 16.447 29.5 17V19.5C29.5 19.766 29.605 20.02 29.793 20.207L31.293 21.707C31.488 21.902 31.744 22 32 22Z",
    fill: "#F5F9FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.491 25.002C13.219 25.007 13 25.229 13 25.502V34.5C13 34.776 13.224 35 13.5 35H15.622C15.846 35 16.042 34.852 16.103 34.637L18.316 26.839C18.459 26.335 18.189 25.805 17.696 25.626C16.79 25.296 15.4 24.97 13.491 25.002Z",
    fill: "#F5F9FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 30.5C33 30.5 29 33.031 27 33.031C25 33.031 22.75 31.5 22.75 31.5C22.75 31.5 25.444 32 27 32C28.556 32 29 31.469 29 30.75C29 29 26.028 28.728 24.524 28.499C23.048 27.677 22.281 27.027 19.836 26.82C19.822 26.963 19.8 27.105 19.76 27.246L17.751 34.326C20.026 35.361 23.944 37 26 37C29 37 37 33 37 32C37 31 36 30.5 35 30.5Z",
    fill: "#F5F9FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepStep2);
export default __webpack_public_path__ + "static/media/step-step-2.8c733c6222430b4d7bd0f760b9127988.svg";
export { ForwardRef as ReactComponent };